<template>
  <section>
    <Toolbar />
    <div class="d-flex flex-column ma-0 pa-0 mt-md-5 mt-lg-5 mt-xl-5 px-5">
      <v-row justify="center" class="ma-0 pa-0">
        <v-col cols="12" class="ma-0 pa-0"> </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-3">
        <v-col cols="12" class="ma-0 pa-0">
          <h2 class="texto-titulo text-center ma-0 pa-0">
            Confirma tu domicilio actual
          </h2>
        </v-col>
      </v-row>
      <v-row
        v-if="
          $store.getters['credito/obtenerObservacionesDevolucion'] != '' &&
          $store.getters['credito/obtenerAplicaDevolucionDomicilio']
        "
        justify="center"
        class="ma-0 pa-0 mx-3 mt-3"
      >
        <v-col cols="12" class="ma-0 pa-0">
          <v-alert
            dense
            text
            type="info"
            :icon="false"
            class="text-center font-weight-black ma-0"
          >
            <p>Observaciones:</p>
            <p>
              {{ $store.getters['credito/obtenerObservacionesDevolucion'] }}
            </p>
          </v-alert>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-5">
        <v-col cols="12" class="ma-0 pa-0">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-container>
              <v-row justify="center" no-gutters>
                <v-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                  <v-text-field
                    outlined
                    v-model="datosDomicilio.calle"
                    label="Calle"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    v-model="datosDomicilio.numExt"
                    label="Num. Exterior"
                  ></v-text-field>
                  <v-row>
                    <v-col>
                      <v-text-field
                        outlined
                        v-model="datosDomicilio.numInt"
                        label="Num. Interior (opcional)"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        outlined
                        v-model="datosDomicilio.cp"
                        label="C.P."
                        @change="obtenLocalidad"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-select
                    v-model="datosDomicilio.selectedColonia"
                    :items="colonias"
                    label="Colonia"
                    item-text="Nombre_Colonia"
                    item-value="Id_Colonia_CNBV"
                    outlined
                    :loading="cargando"
                  ></v-select>
                  <!-- <v-select
                    v-model="datosDomicilio.selectedMunicipio"
                    :items="municipios"
                    label="Municipio"
                    item-text="val"
                    item-value="id_localidad"
                    readonly
                    outlined
                  ></v-select> -->
                  <!-- <v-select
                    v-model="datosDomicilio.selectedEntidad"
                    :items="estados"
                    label="Entidad Federativa"
                    item-text="val"
                    item-value="id_entidad_federativa"
                    readonly
                    outlined
                  ></v-select> -->
                  <v-text-field
                    outlined
                    readonly
                    v-model="datosDomicilio.selectedMunicipio.val"
                    label="Municipio"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    readonly
                    v-model="datosDomicilio.selectedEntidad.val"
                    label="Entidad Federativa"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0">
        <v-col
          cols="12"
          class="ma-0 pa-0 d-flex flex-row justify-center align-center"
        >
          <v-btn
            class="align-self-center mt-0 mx-2"
            v-bind:class="{ 'd-none': !restaurarVisible }"
            color="primary"
            text
            elevation="2"
            @click="restaurarInfo"
            >Restaurar<v-icon right light>mdi-restore</v-icon></v-btn
          >
          <v-btn
            class="align-self-center mt-0 mr-2 mx-2"
            color="primary"
            elevation="2"
            @click="confirmar"
            :disabled="!validForm"
            >{{ textoBoton }}<v-icon right light>mdi-arrow-right</v-icon></v-btn
          >
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
import Toolbar from '@/components/compartidos/Toolbar.vue'
import PersonaService from '@/servicios/persona'
import { ALERTA_ERROR } from '@/utilidades/utilidades'
// import ActualizaDomicilioSolicitudMixin from '@/mixins/persona/actualizaDomicilioSolicitud.mixin'
import creditoService from '@/servicios/credito'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'

export default {
  components: {
    Toolbar,
  },
  mixins: [InsertaLogMixin],
  name: 'DatosDomicilio',
  data: () => ({
    datosDomicilio: '',
    valid: true,
    colonias: [],
    estados: [],
    municipios: [],
    etapaProceso: 'Hazte socio',
    textoBoton: 'Confirmar',
    restaurarVisible: false,
    datosDomicilioBk: '',
    cargando: false,
  }),
  created() {
    // this.$store.getters['persona/obtenerPersona'].tipoPersona != 2
    //   ? this.$router.push('cargaDocuemntos')
    //   : ''
    this.datosDomicilio =
      this.$store.getters['persona/obtenerPersona'].datosDomicilio
    this.datosDomicilioBk =
      this.$store.getters['persona/obtenerDireccionOriginal']
  },
  mounted() {
    this.actualizaBoton(false)
    if (this.datosDomicilio.cp) {
      this.obtenLocalidad()
    } else {
      this.datosDomicilioBk = null
    }
    this.InsertaLog()
  },
  watch: {
    datosDomicilio: {
      handler: function (v) {
        if (!this.cargando) {
          this.camposDomicilioIguales(
            this.datosDomicilio,
            this.datosDomicilioBk
          )
            ? this.actualizaBoton(false)
            : this.actualizaBoton(true)
          // this.obtenLocalidad()
        }
        this.$gtag.event('actualizaDomicilio', {
          event_category: 'change_in_window',
          event_label: 'Se actualizó el domicilio',
          value: v,
        })
      },
      deep: true,
    },
    // 'datosDomicilio.cp': {
    //   handler: function () {
    //     console.log('wacher chido')
    //     if (!this.cargando) {
    //       this.obtenLocalidad()
    //     }
    //   },
    //   deep: true,
    // },
  },
  computed: {
    validForm() {
      // console.log(this.datosDomicilio)
      if (this.datosDomicilio.calle == '') return false
      if (this.datosDomicilio.numExt == '') return false
      if (this.datosDomicilio.cp == '') return false
      if (this.datosDomicilio.selectedColonia == '') return false
      return true
    },
    aplicaDevolDomicilio() {
      return this.$store.getters['credito/obtenerAplicaDevolucionDomicilio']
    },
  },
  methods: {
    async obtenLocalidad() {
      this.datosDomicilio.selectedColonia = ''
      let result
      try {
        this.cargando = true
        result = await PersonaService.obtenerLocalidad(this.datosDomicilio.cp)
        this.cargando = false
        if (result.data.Codigo == 200) {
          this.datosDomicilio.selectedEntidad = {
            id_entidad_federativa: result.data.Modelo.Entidad
              .ID_ENTIDAD_FEDERATIVA
              ? result.data.Modelo.Entidad.ID_ENTIDAD_FEDERATIVA
              : this.datosDomicilio.selectedEntidad.id_entidad_federativa,
            val: result.data.Modelo.Entidad.DESCRIPCION
              ? result.data.Modelo.Entidad.DESCRIPCION
              : this.datosDomicilio.selectedEntidad.val,
          }
          this.datosDomicilio.selectedMunicipio = {
            id_localidad: result.data.Modelo.Entidad.Localidades[0]
              .Id_Localidad_CNBV
              ? result.data.Modelo.Entidad.Localidades[0].Id_Localidad_CNBV
              : this.datosDomicilio.selectedMunicipio.id_localidad,
            val: result.data.Modelo.Entidad.Localidades[0].Nombre_Localidad
              ? result.data.Modelo.Entidad.Localidades[0].Nombre_Localidad
              : this.datosDomicilio.selectedMunicipio.val,
          }
          this.colonias = result.data.Modelo.Entidad.Localidades[0].Colonias
          if (this.datosDomicilioBk.selectedColonia != '')
            this.colonias.push(this.datosDomicilioBk.selectedColonia)
        } else {
          this.enviarAlertaError(
            result.data.Mensaje,
            ALERTA_ERROR.tiempo,
            ALERTA_ERROR.visible
          )
        }
      } catch {
        this.enviarAlertaError(
          ALERTA_ERROR.mensaje,
          ALERTA_ERROR.tiempo,
          ALERTA_ERROR.visible
        )
        this.cargando = false
      }
    },
    actualizaBoton(val) {
      this.textoBoton = val ? 'Actualizar' : 'Confirmar'
      this.restaurarVisible = val
    },
    camposDomicilioIguales(orig, bk) {
      if (orig.calle != bk.calle) return false
      if (orig.cp != bk.cp) return false
      if (orig.numExt != bk.numExt) return false
      if (orig.numInt != bk.numInt) return false
      if (orig.selectedColonia != bk.selectedColonia) return false
      // if (orig.selectedEntidad != bk.selectedEntidad) return false
      // if (orig.selectedMunicipio != bk.selectedMunicipio) return false
      return true
    },
    restaurarInfo() {
      Object.assign(this.datosDomicilio, this.datosDomicilioBk)
      this.textoBoton = 'Confirmar'
      this.restaurarVisible = false
      this.obtenLocalidad()
      this.$gtag.event('restauraDomicilio', {
        event_category: 'change_in_window',
        event_label: 'Se restauro el domicilio original',
        value: 1,
      })
    },
    confirmar() {
      if (this.$store.getters['credito/obtenerAplicaDevolucionDomicilio']) {
        this.cargando = true
        const request = {
          folioDigital: this.$store.getters['credito/obtenerFolioDigital'],
          calle: this.datosDomicilio.calle,
          numero_exterior: this.datosDomicilio.numExt,
          numero_interior: this.datosDomicilio.numInt,
          id_colonia_cnbv: this.datosDomicilio.selectedColonia,
        }
        // this.actualizaDomicilioSolicitud(request)
        creditoService
          .actualizarDomicilioSolicitud(request)
          .then((result) => {
            this.cargando = false
            if (result.status !== 200) {
              this.enviarAlertaError(
                'Ocurrio un error, reintenta más tarde',
                ALERTA_ERROR.tiempo,
                ALERTA_ERROR.visible
              )
              return
            }
            const data = result.data
            if (data.Codigo !== 200) {
              this.enviarAlertaError(
                'Ocurrio un error, reintenta más tarde',
                ALERTA_ERROR.tiempo,
                ALERTA_ERROR.visible
              )
              return
            }
            this.$router.push('/actualizaDocumentos')
          })
          .catch((err) => {
            this.cargando = false
            console.error(err)
            this.enviarAlertaError(
              'Ocurrio un error, reintenta más tarde',
              ALERTA_ERROR.tiempo,
              ALERTA_ERROR.visible
            )
          })
      } else {
        this.$store.dispatch('persona/actualizarDireccion', this.datosDomicilio)
        this.$router.push('cargaDocumentos')
      }
    },
  },
}
</script>

<style scoped>
section {
  user-select: none;
}
</style>
